import React, { useEffect, useState } from "react";
import SectionHeader from "./SectionHeader";
import LRSelectModal from "./LRSelectModal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { createManifest, getNextManifestNo } from "../services/manifestService";
import { getDocketEntries } from "../services/docketEntryService";
import { Delete, Trash2 } from "lucide-react";
import CustomDropdown from "./CustomDropdown";
import { destinationOptions, generateNextUniqueNo } from "../utils/helper";

const ManifestForm = ({ manifest, setManifest, isPreview = false }) => {
  const { user } = useSelector((state) => state.user);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLRs, setSelectedLRs] = useState([]);
  const [docketList, setDocketList] = useState([]);

  /* ------------------ Handlers ------------------ */

  const handleChange = (e, index = null) => {
    const { name, value } = e.target;

    if (index !== null) {
      const shipments = [...manifest.shipments];
      shipments[index][name] = value;
      setManifest({ ...manifest, shipments });
    } else {
      setManifest({ ...manifest, [name]: value });
    }
  };

  // const addSelectedLRs = () => {
  //   const existingLRs = manifest.shipments.map((s) => s.lrNo);

  //   const newShipments = selectedLRs
  //     .filter((lr) => !existingLRs.includes(lr))
  //     .map((lr) => ({
  //       lrNo: lr,
  //       boxes: "",
  //       weight: "",
  //       destination: "",
  //       nextHub: "",
  //     }));

  //   setManifest((prev) => ({
  //     ...prev,
  //     shipments: [...prev.shipments, ...newShipments],
  //   }));

  //   setSelectedLRs([]);
  //   setIsModalOpen(false);
  // };
  const addSelectedLRs = () => {
    const existingLRs = manifest.shipments.map((s) => s.lrNo);

    const newShipments = selectedLRs
      .filter((lr) => !existingLRs.includes(lr))
      .map((lr) => {
        const docket = docketList?.find((d) => d.docketNumber === lr);

        return {
          lrNo: lr,
          boxes: docket?.numberOfBoxes || 0,
          weight: docket?.actualWeight || 0,
          destination: docket?.destination || "",
          nextHub: manifest?.destination || "",
        };
      });

    setManifest((prev) => ({
      ...prev,
      shipments: [...prev.shipments, ...newShipments],
    }));

    setSelectedLRs([]);
    setIsModalOpen(false);
  };
  const handlePrint = () => window.print();

  /* ------------------ Effects ------------------ */

  useEffect(() => {
    const totalPackages = manifest?.shipments.reduce(
      (sum, s) => sum + (Number(s.boxes) || 0),
      0,
    );

    const totalWeight = manifest?.shipments.reduce(
      (sum, s) => sum + (Number(s.weight) || 0),
      0,
    );

    setManifest((prev) => ({
      ...prev,
      totalConsignments: prev?.shipments?.length,
      totalPackages,
      totalWeight,
    }));
  }, [manifest.shipments]);

  useEffect(() => {
    const fetchDockets = async () => {
      try {
        const res = await getDocketEntries(user?.branch?.code || "");
        if (res?.status === 200) {
          setDocketList(res?.data || []);
        }
      } catch (err) {
        console.error("Failed to load dockets", err);
      }
    };

    fetchDockets();
  }, [user?.branch?.code]);

  const handleLrModalClose = () => {
    setIsModalOpen(false);
    setSelectedLRs([]);
  };

  // console.log("selectedLr", selectedLRs);

  return (
    <div>
      <div className=" mx-auto space-y-4 text-sm">
        {/* Manifest Info */}
        <div className="bg-white rounded-xl shadow-sm p-3 grid grid-cols-3 gap-4">
          <div>
            <label className="text-xs font-semibold text-slate-600">
              Manifest No<span className="text-red-500">*</span>
            </label>

            <div className="flex gap-2">
              <input
                type="text"
                name="manifestNo"
                value={manifest.manifestNo}
                readOnly
                placeholder="Click Generate"
                className="mt-1 w-full text-sm rounded-lg border px-3 py-2 bg-gray-100"
              />
              {!isPreview && (
                <button
                  type="button"
                  disabled={!!manifest.manifestNo}
                  onClick={async () => {
                    try {
                      const res = await getNextManifestNo();
                      console.log("res", res);
                      setManifest((prev) => ({
                        ...prev,
                        manifestNo: res?.data?.manifestNo,
                      }));
                    } catch (err) {
                      console.error(err);
                      toast.error("Failed to generate Manifest No");
                    }
                  }}
                  className="mt-1 px-3 py-2 bg-blue-600 text-white rounded-lg text-xs"
                >
                  Generate
                </button>
              )}
            </div>
          </div>
          {[
            // ["Dispatch Date", "dispatchDate", "datetime-local"],
            // ["Manifest No", "manifestNo", "text", true],
            // ["Destination", "destination", "text"],
            ["Vehicle No", "vehicleNo", "text"],
          ].map(([label, name, type, required]) => (
            <div key={name}>
              <label className="text-xs font-semibold text-slate-600">
                {label}
                {required && <span className="text-red-500">*</span>}
              </label>
              <input
                type={type}
                name={name}
                value={manifest[name]}
                onChange={handleChange}
                className="mt-1 w-full text-sm rounded-lg border px-3 py-2"
              />
            </div>
          ))}
          <div>
            <div className="text-xs font-semibold text-slate-600 mb-2">
              Destination<span className="text-red-500">*</span>
            </div>
            <CustomDropdown
              // label="Destination"
              // required
              value={manifest.destination}
              options={destinationOptions}
              onChange={(val) => setManifest({ ...manifest, destination: val })}
            />
          </div>
        </div>

        {/* Shipments */}
        <div className="bg-white rounded-xl shadow-sm p-3">
          <div className="flex justify-between items-center mb-3">
            <h2 className="text-sm font-semibold">Shipment Details</h2>
            <button
              onClick={() => setIsModalOpen(true)}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg text-xs"
            >
              + Add LR
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full border border-gray-300 border-collapse rounded-lg ">
              <thead className="bg-slate-100 text-xs">
                <tr>
                  {[
                    "SL",
                    "LR#",
                    "Boxes",
                    "Weight",
                    "Destination",
                    "Next Hub",
                    "",
                  ].map((h) => (
                    <th
                      key={h}
                      className="px-3 py-2 border border-gray-300 text-left"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {manifest.shipments.map((row, index) => (
                  <tr key={index} className="text-sm">
                    <td className="px-3 py-2 text-center border border-gray-300">
                      {index + 1}
                    </td>

                    <td className="px-3 py-2 border border-gray-300">
                      <input
                        readOnly
                        value={row.lrNo}
                        className="w-full outline-none"
                      />
                    </td>

                    {["boxes", "weight", "destination", "nextHub"].map(
                      (field) => (
                        <td
                          key={field}
                          className="px-3 py-2 border border-gray-300"
                        >
                          <input
                            name={field}
                            readOnly
                            value={row[field]}
                            // onChange={(e) => handleChange(e, index)}
                            className="w-full rounded py-1 outline-none"
                          />
                        </td>
                      ),
                    )}

                    <td className="px-3 py-2 text-center border border-gray-300">
                      <button
                        onClick={() =>
                          setManifest({
                            ...manifest,
                            shipments: manifest.shipments.filter(
                              (_, i) => i !== index,
                            ),
                          })
                        }
                        className="text-red-600"
                      >
                        {/* Delete */}
                        <Trash2 size={16} />
                      </button>
                    </td>
                  </tr>
                ))}

                {manifest.shipments.length === 0 && (
                  <tr>
                    <td
                      colSpan={8}
                      className="text-center text-xs py-6 text-slate-400 border border-gray-300"
                    >
                      No LR added yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* Summary */}
        <div className="bg-white rounded-xl shadow-sm p-3 grid grid-cols-3 gap-4">
          {[
            ["totalConsignments", "Total Consignments"],
            ["totalPackages", "Total Packages"],
            ["totalWeight", "Total Weight (Kg)"],
          ].map(([name, label]) => (
            <div key={name}>
              <label className="text-xs font-medium text-slate-600">
                {label}
              </label>
              <input
                readOnly
                value={manifest[name]}
                className="mt-1 w-full rounded-lg border px-3 py-2 text-left bg-slate-50"
              />
            </div>
          ))}
        </div>
        {/* Footer */}
        <div className="bg-white rounded-xl text-sm shadow-sm p-3 grid grid-cols-2 gap-6">
          {[
            ["driverName", "Driver Name"],
            ["loadingMaster", "Loading Master"],
          ].map(([name, label]) => (
            <div key={name}>
              <label className="text-xs font-semibold text-slate-600">
                {label}
              </label>
              <input
                name={name}
                value={manifest[name]}
                onChange={handleChange}
                className="mt-1 w-full border rounded px-3 py-2"
              />
            </div>
          ))}
        </div>
      </div>

      {/* LR Modal */}
      <LRSelectModal
        isOpen={isModalOpen}
        onClose={handleLrModalClose}
        availableLRs={docketList?.map((d) => d.docketNumber)}
        selectedLRs={selectedLRs}
        setSelectedLRs={setSelectedLRs}
        onConfirm={addSelectedLRs}
      />
    </div>
  );
};

export default ManifestForm;
